export class CommentModel {
    violationID: number;
    commentText: string;
    personID: string;
    mtn: string;
  addedBy: string;
  IsResolve: number;
  IsViolation: boolean;
}
